<template>
  <div class="m-market-part-desc">
    <div class="m-market-row">
      <div class="m-title" />
      <template v-for="title in outcomeData.cols">
        <div
          :key="title"
          class="m-title"
        >
          {{ title }}
        </div>
      </template>
    </div>
    <template v-for="(row, key) in outcomeData.rows">
      <div
        :key="key"
        class="m-market-row"
      >
        <div class="m-outcome m-outcome-desc">
          <span class="m-outcome-desc-name">{{ key }}</span>
        </div>
        <template v-for="outcome in row">
          <Outcome
            :key="outcome.id"
            :outcome="outcome"
            :market="market"
            :event="event"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 四、拆开部分desc
 * 规则描述：对于部分market，desc可以拆出来，使得odds value单独罗列在selection中；
 * 要求：desc可拆的markets
 */

import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market4PartDesc',
  components: {
    Outcome
  },
  props: {
    market: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      outcomeData: {}
    }
  },
  watch: {
    'market.outcomes.order'(val) {
      if (val) {
        this.outcomeData = this.getOutcomeData()
      }
    }
  },
  created() {
    this.outcomeData = this.getOutcomeData()
  },
  methods: {
    getOutcomeData() {
      const { map, order } = this.market.outcomes
      const rows = {}
      const cols = []
      order.forEach((id) => {
        const outcome = map[id]
        const [rowDesc, colDesc] = outcome.description.split('by')
        if (colDesc) {
          const colKey = rowDesc.trim()
          const rowKey = colDesc.trim()
          if (rows[rowKey]) {
            rows[rowKey].push(outcome)
          } else {
            rows[rowKey] = [outcome]
          }
          if (colDesc && !cols.includes(colKey)) {
            cols.push(colKey)
          }
        } else {
          rows[rowDesc] = [outcome]
        }
      })
      return { cols, rows }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-market-part-desc {
  .m-market-row {
    .m-title:first-child,
    .m-outcome.m-outcome-desc {
      width: 90/@rem;
      flex: none;
    }
  }
}
</style>
